// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__37OI8","errorLogs":"EditorFooter_errorLogs__2u1QB"};